import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  name: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  iconButton: {
    display: 'flex',
    flexShrink: 0,
    padding: 0,
    border: 0,
    background: 'none',
    cursor: 'pointer'
  },
  addButton: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: 0,
    border: 0,
    background: 'none',
    font: 'inherit',
    fontSize: 16,
    lineHeight: '24px',
    color: theme.colorPalette.orange_50,
    ...reskinStyles(theme, { color: theme.colors.action_text }),
    cursor: 'pointer',
    '&:disabled': {
      opacity: 0.5,
      cursor: 'default'
    }
  },
  icon: {
    width: 16,
    height: 16
  }
}));

export default useStyles;
